export default __webpack_public_path__ + "static/media/faction-me.e77bbb93.png";